import { cn } from './utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

function LoadingSpinner({ className, size = 'md', message }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <div
        className={cn(
          'border-[#A66B32]/25 border-t-[#A66B32] rounded-full animate-spin',
          sizeClasses[size],
        )}
      />
      {message && <p className="text-gray-600 mt-4">{message}</p>}
    </div>
  );
}

export { LoadingSpinner };
